import React, { Component } from 'react';
import { connect } from 'react-redux';
import { SEARCH_TYPES, ISort } from '../models';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { IStore } from 'reducers/index';
import { ISortModel } from 'reducers/filters/models';
import { setSort, resetSort } from 'actions/filters';
import queryString from 'query-string';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { displayFilters } from 'actions/filters';
import { isEmptyError } from 'utilities/validate';
import { SearchResults } from '../SearchResults';
import { ISearchs } from 'reducers/search/models';
import { fetchSearch, resetSearch } from 'actions/search';
import { setSortForTable } from 'utilities/tables';
import { FiltersInput } from 'modules/filters/components/FiltersInput';
import { FiltersSelect } from 'modules/filters/components/FiltersSelect';
import InPageDialog from '../../../../components/page-dialog';
import { Filters } from 'modules/filters/containers/Filters';
import { Search } from '../Search';
import { IFeatureToggleModel } from 'reducers/featureToggle/models';
import { isFeatureEnabled } from 'utilities/util';
import { FEATURE_TOGGLES } from 'constants/featureToggles';
interface IMapDispatchToProps {
    fetchSearch: (pageNumber: number, pageSize: number, genericSearch: string) => Promise<void>;
    setSort: (sort: ISortModel) => void;
    resetSort: () => void;
    displayFilters: (hideFilters: boolean, target: string) => void;
    resetSearch: () => void;
}
interface IMapStateToProps {
    isFetchSearchDataLoading: boolean;
    isFetchSearchDataError: boolean;
    searchPendingError: string | string[],
    data: ISearchs;
    featureToggles: IFeatureToggleModel[];
}
interface IProps extends RouteComponentProps, IMapStateToProps, IMapDispatchToProps { }
interface IState {
    isDisabledSubmit: boolean;
    genericSearch: string;
    sorted: ISort[] | any[];
    page: number;
    pageSize: number;
    totalCount: number;
    isFetchinProgress: boolean;
    clearFilters: boolean;
    pendingError: string | string[];
    ETAFrom: boolean,
    ETDFrom: boolean,
    activeTab: number,
    internalActiveTab: number,
    typeOfSearch: string,
    booking: any[],
    equipment: any[],
    fcr: any[],
    cbl: any[],
    data: any[],
    filters: any[],
    triggerChange: any;
    shouldClear: boolean;
    pageResult: number;
    showDialog: boolean;
    hasData: boolean;
    errorMsg: string | null
}
export class _SearchMain extends Component<IProps, IState>{
    public tableRef: any = React.createRef();
    public state = {
        isDisabledSubmit: false,
        genericSearch: '',
        sorted: [],
        page: 1,
        pageSize: 10,
        totalCount: 0,
        isFetchinProgress: true,
        clearFilters: false,
        ETAFrom: false,
        ETDFrom: false,
        pendingError: '',
        typeOfSearch: SEARCH_TYPES.GENERAL,
        typeOfFilter: SEARCH_TYPES.GENERAL,
        activeTab: 1,
        internalActiveTab: 1,
        booking: [],
        equipment: [],
        fcr: [],
        cbl: [],
        data: [],
        filters: [],
        triggerChange: null,
        shouldClear: false,
        pageResult: 1,
        showDialog: false,
        hasData: false,
        errorMsg: ''
    };
    constructor(props: any) {
        super(props);
    }
    public componentDidMount() {
        this.props.displayFilters(false, 'jobCostingFiltersGeneral')
        this.props.resetSort();
        const query = queryString.parse(this.props.location.search);
        if (query.tab) {
            this.setSelection(Number(query.tab))
        }
        this.setState({
            triggerChange: this.getCurrentTrigger(),
            isFetchinProgress: false,
        });
        if (this.props.data && this.props.data.result.length > 0) {
            const pageNum = this.props.data.page ? this.props.data.page : this.props.data.pageNumber ? this.props.data.pageNumber : 1;
            const newData = this.parseData(this.props.data.result, pageNum, this.props.data.pageSize, this.props.data.totalCount)
            this.setState({
                ...newData,
                totalCount: this.props.data.totalCount,
                pageResult: 1
            })

        }
    }
    public componentDidUpdate(props: any, state: any) {
        if (this.state.internalActiveTab !== state.internalActiveTab) {
            this.shouldSubmit();
            if (this.state.internalActiveTab === 1) {
                this.setState({ isDisabledSubmit: true })
            }
        }
        if (this.props.isFetchSearchDataError !== props.isFetchSearchDataError) {
            this.setState({
                showDialog: this.props.isFetchSearchDataError,
                isFetchinProgress: false,
                errorMsg: this.props.searchPendingError.toString() ? this.props.searchPendingError.toString() : 'Request Error'
            })
            if (this.props.location.search) {
                this.props.history.push(this.props.location.pathname);
            }
        }
        if (this.props.data.result !== props.data.result) {
            const cloneData = Object.assign([], this.props.data.result);
            const pageNum = this.props.data.page ? this.props.data.page : this.props.data.pageNumber ? this.props.data.pageNumber : 1;
            const newData = this.parseData(cloneData, pageNum, this.props.data.pageSize, this.props.data.totalCount)
            if (this.props.location.search) {
                this.props.history.push(this.props.location.pathname);
            }
            this.setState({
                ...newData,
                totalCount: this.props.data.totalCount,
                pageResult: 1,
            }, () => {
                const selected = this.tableRef.current.querySelectorAll('.-pageSizeOptions select')[this.state.internalActiveTab === 1 ? 0 : 1]
                if (selected && selected.value) {
                    selected.value = this.state.pageSize
                }
            })
        }
        if (this.props.searchPendingError !== props.searchPendingError && this.props.isFetchSearchDataError === true) {
            const error = isEmptyError(this.props.searchPendingError, 'Server error');
            this.setState({
                pendingError: error,
                isFetchinProgress: false,
                hasData: false,
                pageResult: this.state.activeTab
            })
            if (this.props.location.search) {
                this.props.history.push(this.props.location.pathname);
            }
        }
    }
    public watch = (e: any) => {
        if (!e.ReferenceNumber ||
            e.ReferenceNumber && e.ReferenceNumber.length <= 4) {
            this.setState({ isDisabledSubmit: true })
        } else {
            this.setState({ isDisabledSubmit: false })
        }
    }
    public componentWillUnmount(){
        this.props.resetSort()
    }
    public render() {
        const isExtraDocumentFeatureEnabled = isFeatureEnabled(FEATURE_TOGGLES.EXTRA_DOCUMENT, this.props.featureToggles);
        const isHblConsumptionEnabled = isFeatureEnabled(FEATURE_TOGGLES.FINOPS_HBL_CONSUMPTION, this.props.featureToggles);
        return (
            <Search triggerFetch={() => this.targetFetch()}>
                <InPageDialog
                    showDialog={this.state.showDialog}
                    type={'error'}
                    message={this.state.errorMsg}
                    closeMethod={() => this.setState({ showDialog: false, errorMsg: '' })} />
                <Filters
                    tableNameKey="jobCostingFiltersGeneral"
                    genericFilter={this.state.genericSearch}
                    fetchFunction={() => this.fetchReset()}
                    filters={[
                        <FiltersInput
                            key="ReferenceNumber"
                            name="ReferenceNumber"
                            label="Reference Number"
                            id={'ReferenceNumber'}
                        />,
                        <FiltersSelect
                            className="col-40"
                            key="DocumentType"
                            name="DocumentType"
                            id="DocumentType"
                            label="Document Type"
                            isArray={true}
                            type={'array'}
                            options={[
                                {
                                    optionText: '',
                                    label: 'Booking',
                                    value: 'Booking',
                                }, {
                                    optionText: '',
                                    label: 'CBL',
                                    value: 'CBL',
                                }, {
                                    optionText: '',
                                    label: 'Equipment/CLR',
                                    value: 'EquipmentClr',
                                }, {
                                    optionText: '',
                                    label: isExtraDocumentFeatureEnabled ? 'Document' : (isHblConsumptionEnabled ? 'FCR/HBL' : 'FCR'),
                                    value: 'FCR',
                                }
                            ]}
                        />
                    ]}
                    resetErrors={() => this.resetDates()}
                    watchChanges={this.watch}
                    disableSubmit={this.state.activeTab === 1 && (this.state.ETAFrom || this.state.ETDFrom) || this.state.isDisabledSubmit}
                    triggerFilter={this.state.triggerChange}
                    triggerClear={this.state.shouldClear}
                    resetPaging={(pageNumber: any, pageSize: any) => {
                        if (this.tableRef && this.tableRef.current && this.tableRef.current.querySelector('.-pageJump input')) {
                            this.tableRef.current.querySelector('.-pageJump input').value = 1
                        }
                        this.setState({
                            page: 1,
                            totalCount: 0,
                            clearFilters: false,
                            data: [],
                            booking: [],
                            fcr: [],
                            equipment: [],
                            cbl: [],
                            hasData: false
                        })
                    }}
                />
                <div ref={this.tableRef}>
                    <SearchResults
                        data={{
                            result: this.state.data,
                            booking: this.state.booking,
                            fcr: this.state.fcr,
                            equipment: this.state.equipment,
                            cbl: this.state.cbl,
                            totalCount: this.state.totalCount
                        }}
                        callbackTab={(e: any) => this.setState({ internalActiveTab: e })}
                        activeTab={this.state.internalActiveTab}
                        targetResult={true}
                        fetchApi={this.justFetch}
                        fetchLoading={this.props.isFetchSearchDataLoading}
                        pageSize={this.state.pageSize}
                        linkAction={(url: string) => this.props.history.push(url)}
                        featureToggles={this.props.featureToggles}
                    />
                </div>
            </Search>
        );
    }
    private getCurrentTrigger = () => {
        this.setState({ triggerChange: null })
        switch (this.state.internalActiveTab) {
            case 2:
                return { 'DocumentType': ['Booking'] }
                break;
            case 4:
                return { 'DocumentType': ['CBL'] }
                break;
            case 3:
                return { 'DocumentType': ['FCR'] }
                break;
            case 5:
                return { 'DocumentType': ['EquipmentClr'] }
                break;
            default:
                return { 'DocumentType': ['Booking', 'CBL', 'EquipmentClr', 'FCR'] }
                break;
        }
    }
    private parseData = (data: any, page: number, pageSize: number, totalCount: number) => {
        const testData = (type: string): any[] => {
            if (this.state.activeTab === 1) {
                return this.getData(type, data)
            }
            return []
        }
        return {
            page,
            pageSize,
            totalCount,
            isFetchinProgress: false,
            hasData: true,
            data: this.state.activeTab === 1 ? data : [],
            booking: this.state.activeTab === 2 ? data : testData('Booking'),
            fcr: this.state.activeTab === 3 ? data : testData('FCR'),
            equipment: this.state.activeTab === 5 ? data : testData('EquipmentClr'),
            cbl: this.state.activeTab === 4 ? data : testData('CBL'),
        };
    }
    private getData = (filterKey: string, data: any[]) => {
        let newData = [...data];
        newData = newData.filter((el: any) => {
            return el.documentType === filterKey
        })
        return newData
    }
    private setFilters = (id: number) => {
        let currSelected: string = SEARCH_TYPES.GENERAL;
        switch (id) {
            case 2:
                currSelected = SEARCH_TYPES.BOOKING;
                break;
            case 3:
                currSelected = SEARCH_TYPES.FCR;
                break;
            case 4:
                currSelected = SEARCH_TYPES.CBL;
                break;
            case 5:
                currSelected = SEARCH_TYPES.EQUIPMENT;
                break;
            case 6:
                currSelected = SEARCH_TYPES.EXPORTJOB;
                break;
            default:
                currSelected = SEARCH_TYPES.GENERAL;
        }
        return currSelected
    }
    private setSelection = (id: number) => {
        if (id === this.state.activeTab) {
            return
        }
        const getFilters = this.setFilters(id)
        this.setState({
            activeTab: id,
            typeOfSearch: getFilters
        })
        this.props.history.push(`${this.props.location.pathname}?tab=${id}`);
    }
    private shouldSubmit = () => {
        this.setState({
            isFetchinProgress: true,
            data: [],
            booking: [],
            fcr: [],
            equipment: [],
            cbl: [],
            triggerChange: this.getCurrentTrigger()
        }, this.fetchReset)
    }
    private resetDates = () => {
        if (this.props.data && this.props.data.result.length > 0) {
            this.props.resetSearch()
        }
        this.setState({
            sorted: [],
            genericSearch: '',
            page: 1,
            totalCount: 0,
            ETAFrom: false,
            ETDFrom: false,
            clearFilters: true,
            isFetchinProgress: true,
            data: [],
            booking: [],
            fcr: [],
            equipment: [],
            cbl: [],
            shouldClear: true,
            hasData: false,
            pageResult: this.state.activeTab
        })
    };
    private targetFetch = (page: number = 1, pageSize: number = 10) => {
        if (!this.state.isDisabledSubmit) {
            this.setState({
                isFetchinProgress: true
            })
            this.props.fetchSearch(page, pageSize, this.state.genericSearch)
        }
    }
    private fetchReset = (page: number = 1, pageSize: number = 10) => {
        if (this.tableRef && this.tableRef.current && this.tableRef.current.querySelector('.-pageJump input')) {
            this.tableRef.current.querySelector('.-pageJump input').value = 1
        }
        if (!this.state.clearFilters) {
            const p = this.state.page ? this.state.page : page;
            const pS = this.state.pageSize ? this.state.pageSize : pageSize;
            this.setState({
                page: p,
                pageSize: pS,
                isFetchinProgress: true
            });
            this.targetFetch(p, pS)
        }
    };
    private justFetch = (tableData: any) => {
        if (!this.state.isFetchinProgress && !this.state.isDisabledSubmit) {
            this.setState({
                page: tableData.page + 1,
                pageSize: tableData.pageSize,
                isFetchinProgress: true
            }, () => {
                if (tableData.sorted) {
                    this.setState({ sorted: [...tableData.sorted] });
                    setSortForTable(tableData.sorted, this.props.setSort);
                } else if (this.state.sorted && this.state.sorted.length) {
                    setSortForTable(this.state.sorted, this.props.setSort);
                }
                this.props.fetchSearch(tableData.page + 1, tableData.pageSize, this.state.genericSearch)
            })
        }
    };
}
const mapStateToProps = (state: IStore): IMapStateToProps => ({
    isFetchSearchDataLoading: state.search.isFetchSearchDataLoading,
    isFetchSearchDataError: state.search.isFetchSearchDataError,
    searchPendingError: state.search.searchPendingError,
    data: state.search.response,
    featureToggles: state.featureToggle.featureToggles
});

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, Action>): IMapDispatchToProps => ({
    fetchSearch: (pageNumber: number, pageSize: number, genericSearch: string) => dispatch(fetchSearch(pageNumber, pageSize, genericSearch)),
    setSort: (sort: ISortModel) => dispatch(setSort(sort)),
    resetSort: () => dispatch(resetSort()),
    displayFilters: (hideFilters: boolean, target: string) => dispatch(displayFilters(hideFilters, target)),
    resetSearch: () => dispatch(resetSearch())
});
const __SearchMain = connect<IMapStateToProps, IMapDispatchToProps, {}, IStore>(mapStateToProps, mapDispatchToProps)(_SearchMain);
export const SearchMain = withRouter(__SearchMain);